exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-file[data-v-9b7b8a92]{margin:0}.think .tabs[data-v-9b7b8a92]{position:fixed!important;top:0}", ""]);

// exports
